<p-toast
    [key]="key"
    (onClose)="onClose.emit($event)"
    [baseZIndex]="9999999"
></p-toast>
